import React, { useState, useEffect, useRef } from "react";
import Typography from "./Typography";
import { borderRadius, spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";

import { CaretUpDown, FileX } from "@phosphor-icons/react";
import Divider from "./Divider";

import TickerNews from "./TickerNews";
import TickerInsight from "./TickerInsight";

function TickerNewsList({
    tickerNews,
    isCompany
}){
    const { theme } = useTheme(); 
    const [visibleCount, setVisibleCount] = useState(3);
    const [stories, setStories] = useState([]);
    const totalNews = tickerNews.length;
    const isExpanded = visibleCount >= totalNews;

    useEffect(() => {
      if (tickerNews.length > 0) {
        // Extract news items and add type "news"
        const newsItems = tickerNews.map(news => ({ ...news, type: "news" }));

        // Extract all insights
        const allInsights = tickerNews
            .flatMap(news => news.insights?.map(insight => ({ text: insight, type: "insight" })) || []);

        if (isCompany) {
            // Randomly select the same number of insights as news
            const selectedInsights = getRandomItems(allInsights, tickerNews.length);

            // Assign "opinion" type to half of the selected insights
            const halfCount = Math.floor(selectedInsights.length / 2);
            selectedInsights.forEach((insight, index) => {
                if (index < halfCount) {
                    insight.type = "opinion";
                }
            });

            // Merge and shuffle news and selected insights
            const combinedStories = shuffleArray([...newsItems, ...selectedInsights]);

            setStories(combinedStories);
        } else {
            setStories (newsItems);
        }

      }
    }, [tickerNews]);

    const getRandomItems = (array, count) => {
        if (array.length <= count) return array; // If not enough insights, use all available
        const shuffled = shuffleArray([...array]); // Shuffle before selecting
        return shuffled.slice(0, count);
    };

    const shuffleArray = (array) => {
        return array
            .map(value => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);
    };

    const handleToggle = () => {
        setVisibleCount(prev => (prev >= stories.length ? 3 : Math.min(prev + 3, stories.length)));
    };

    // console.log("Mixed Stories:", stories);


    const styles = {
          infoContainer: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: spacing.m,
            height: "48px",
            backgroundColor: theme.colors.fillPrimary,
          },
          sortContainer: {
            display: "inline-flex", 
            justifyContent: "center",
            alignItems: "center",
            gap: spacing.xs,
            width: "fit-content",
            whiteSpace: "nowrap", 
          },
          buttonContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: spacing.l, 
          },
          button:{
            display: "flex",
            height: spacing.xl,
            padding: spacing.m,
            justifyContent: "center",
            alignItems: "center",
            gap: spacing.xs,
            backgroundColor: theme.colors.fillSecondary,
            borderRadius: borderRadius.s,
          }
    
      };
    
    return (
        <div style={{ padding: spacing.xxxs, height: "100%" }}>
            <div style={styles.infoContainer}> 
                <div style={styles.sortContainer}>
                    <Typography variant="supportingCaption" type="editorial" style={{ color: theme.colors.contentSecondary, width: "auto" }}>Sort by Relevance</Typography>
                    <CaretUpDown size={16} style={{ color: theme.colors.contentSecondary }} />
                </div>
                <Typography variant="supportingCaption" type="editorial" style={{ color: theme.colors.contentSecondary, width: "100%", textAlign: "right"}}>{totalNews} stories total</Typography>
            </div>  
            {stories.slice(0, visibleCount).map((story, index) =>
                story.type === "news" ? (
                    <TickerNews key={index} item={story} />
                ) : (
                    <TickerInsight key={index} item={story} />
                )
            )}
            <div style={styles.buttonContainer}>
                <button style={styles.button} onClick={handleToggle}>
                    <Typography variant="button" type="utility" style={{ color: theme.colors.contentPrimary }}>
                        {isExpanded ? "Collapse All" : "View More"}
                    </Typography>
                </button>
            </div>
        </div>
    )
}

export default TickerNewsList;